import * as React from 'react';

import { Icon } from '@blueprintjs/core';

interface IBreachIndicatorProps {
  status: 'flag' | 'pass' | 'cannot_test' | 'info' | 'not_applicable' | 'information' | 'disabled' | 'error';
  reason?: string;
  iconSize?: number;
}

const BreachIndicator = ({ status, reason, iconSize = 17 }: IBreachIndicatorProps) => {
  let color;
  let text;
  let icon;

  switch (status) {
    case 'flag':
      color = 'red';
      text = 'Breach occurred';
      icon = 'delete';
      break;
    case 'pass':
      color = 'green';
      text = 'No breach occurred';
      icon = 'endorsed';
      break;
    case 'cannot_test':
      color = 'grey';
      text = 'Test cannot be performed';
      icon = 'disable';
      break;
    case 'info':
      color = 'blue';
      text = 'Information Only';
      icon = 'info-sign';
      break;
    case 'not_applicable':
      color = 'grey';
      text = 'Not Applicable';
      icon = 'disable';
      break;
    case 'disabled':
      color = 'grey';
      text = 'Disabled';
      icon = 'disable';
      break;
    case 'error':
      color = 'yellow';
      text = 'Error';
      icon = 'warning-sign';
      break;
    default:
      color = 'white';
      text = '';
      icon = '';
      break;
  }

  if (reason) {
    text += ` (${reason})`;
  }

  return (
    <span>
      <Icon style={{ color }} icon={icon} iconSize={iconSize} className="mar-r-1" />
      {text}
    </span>
  );
};

export default BreachIndicator;
